/**
 * Separator Component
 * Horizontal line with centered text
 */

import { designTokens } from '../../constants/designTokens';

interface SeparatorProps {
  text: string;
  className?: string;
}

export function Separator({ text, className = '' }: SeparatorProps) {
  return (
    <>
      <div className={`separator ${className}`}>
        <span className="separator-line"></span>
        <span className="separator-text">{text}</span>
        <span className="separator-line"></span>
      </div>

      <style>{`
        .separator {
          display: flex;
          align-items: center;
          gap: ${designTokens.spacing.md};
          width: 100%;
          margin: ${designTokens.spacing.sm} 0;
        }

        .separator-line {
          flex: 1;
          height: 1px;
          background-color: ${designTokens.colors.border.light};
        }

        .separator-text {
          color: ${designTokens.colors.text.secondary};
          font-size: ${designTokens.typography.fontSize.sm};
          font-weight: ${designTokens.typography.fontWeight.normal};
          white-space: nowrap;
        }

        /* Mobile (up to 767px) */
        ${designTokens.media.mobile} {
          .separator {
            margin: ${designTokens.spacing.xs} 0;
          }
          
          .separator-text {
            font-size: ${designTokens.typography.fontSize.xs};
          }
        }

        /* Desktop (1024px+) */
        ${designTokens.media.desktop} {
          .separator {
            margin: ${designTokens.spacing.md} 0;
          }
          
          .separator-text {
            font-size: ${designTokens.typography.fontSize.base};
          }
        }
      `}</style>
    </>
  );
}